import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const lockGmpBudgetHandler = async (props) => {
  const { fileRef, budgetLastUpdated, budgetId } = props;

  const response = await BudgetAPI.postWOP(`${budgetId}/$lockgmp`, {
    lastUpdated: budgetLastUpdated,
    file: fileRef,
  });
  return response.data;
};

export default lockGmpBudgetHandler;
